module.exports = __webpack_public_path__ + "img/check.c35172f7.png";